<template>
	<!-- footer -->
	<div class="footer" ref="foot">
		<!--  顾问弹出层  -->
		<el-dialog :visible.sync="adminShow" custom-class="admin-dialog" :before-close="handleClose">
			<div class="admin-show">
				<div class="qrcode">
					<img :src="adminData.qrcode" alt="美课教育" />
					<!--     <img :src="adminData.qrcode" /> -->
				</div>
			</div>
		</el-dialog>
		<!-- bottom 悬浮框 -->
	<!-- 	<div id="bottom-box" v-if="footShow == true" class="bottom-phone-box" :class="{boxFixed:isCome}">
			<div class="college-big-box">
				<div class="teacher">
					<img src="@/assets/footer/foot-main-left.png" alt="美课教育" />
				</div>
				<div class="text">
					立即
					<span>免费领取</span>
					直播课
				</div>
				<div class="bottom-phone-big-box">
					<el-form ref="form" :model="form" :rules="rules">
						<el-form-item prop="phone">
							<el-input type="text" class="input-row" placeholder="请输入您的手机号" v-model="form.phone" />
						</el-form-item>
					</el-form>
				</div>
				<el-button class="get-btn" @click="btnClick">提交领课</el-button>
				<div class="right">
					<img src="@/assets/footer/foot-main-right.png" alt="美课教育" />
				</div>
			</div>
		</div> -->
		<!-- bottom 悬浮框 end-->
		<div class="footer-width">
			<div class="footer-nav-beian">
				<div>
					<a href="/#/useragreement" target="_blank">
						用户协议
					</a>
					<span class="decorate-line">|</span>
					<a href="/#/statement" target="_blank">
						官方声明
					</a>
					
				</div>
				<div>
					<a href="https://beian.miit.gov.cn/" target="_blank">
						备案号：皖ICP备2022015993号
					</a>
					<span class="decorate-line">|</span>
					Copyright © 2013-2022 美课教育
				</div>
				<!--    <div>
          <img src="@/assets/img69.png" alt="美课教育" />
          公司地址：山东省青岛市李沧区九水路29-5号
           <span class="decorate-line">|</span>
            座机号：010-888888888
        </div> -->
			</div>
		</div>
		<!-- left 悬浮框 -->
	  <div class="big-box">
			<div class="service-wrapper">
		<!-- 		<div class="margin-wrapper-servicer goto-dp">
					<router-link to="/about">
						<i class="serviser-icon goto-dp-icon">
							<img src="@/assets/logos.png" style="width:25px" />
						</i>
						<div class="">走进美课</div>
					</router-link>
				</div>
				<div class="margin-wrapper-servicer goto-dp">
					<router-link to="/Publishlist">
						<i class="serviser-icon goto-dp-icon">
							<img src="@/assets/img110.png" />
						</i>
						<div class="">作业提交</div>
					</router-link>
				</div>
				<div class="margin-wrapper-servicer goto-dp" onclick="__egeelTalk()">
					<i class="serviser-icon goto-dp-icon">
						<img src="@/assets/img102.png" />
					</i>
					<div class="">在线咨询</div>
				</div>

				<div class="margin-wrapper-servicer goto-dp" style="border:none; margin-bottom:0px;">
					<router-link to="/PersonalEdit">
						<i class="serviser-icon goto-dp-icon">
							<img src="@/assets/img101.png" />
						</i>
						<div class="">找回密码</div>
					</router-link>
				</div> -->
        <div class="margin-wrapper-servicer goto-dp" onclick="__egeelTalk()">
        	<i class="serviser-icon goto-dp-icon">
        		<img src="@/assets/img107.png" />
        	</i>
        	<div class="">建议投诉</div>
        </div>
        <div class="margin-wrapper-servicer goto-dp" style="padding-bottom:10px;">
        	<router-link to="/PersonalEdit">
        		<i class="serviser-icon goto-dp-icon">
        			<img src="@/assets/img108.png" />
        		</i>
            <div class="">咨询热线</div>
        		<div class="">0551<br/>65208087</div>
        	</router-link>
        </div>
        <div class="margin-wrapper-servicer goto-dp" style="border:none;margin-bottom:0px;">
        	<router-link to="/PersonalEdit">
        		<i class="serviser-icon goto-dp-icon">
        			<img src="@/assets/img110.png" />
        		</i>
            <div class="">咨询时间</div>
        		<div class="">9:00-18:00</div>
            <div class="">假期休息</div>
        	</router-link>
        </div>
			</div>
		</div>
		<!-- left 悬浮框 end-->
	</div>
</template>
<script>
	export default {
		props: ['footShow'],
		data() {
			return {
				isCome: 1,
				adminShow: false,
				adminData: {},
				form: {
					phone: "",
				},
				rules: {
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							required: true,
							pattern: /^1[3456789]\d{9}$/,
							message: '手机号格式不正确',
							trigger: 'blur'
						}
					],
				}
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				var top = this.$refs.foot.getBoundingClientRect().top
				if (top - scrollTop < 500) {
					this.isCome = 0;
				} else {
					this.isCome = 1;
				}
			},
			btnClick() {
				// this.$refs["form"].validate((valid) => {
				// 	if (valid) {
				// 		this.$axios({
				// 			method: 'post', // 请求格式
				// 			url: '/api/user/input', // 请求路径
				// 			headers: { // 设置请求头
				// 				token: this.$cookieStore.getCookie('token')
				// 			},
				// 			data: {
				// 				"account": this.form.phone,
				// 				"course": ""
				// 			}
				// 		}).then(res => {
				// 			if (res.data.code == 200) {
				// 				this.$message({
				// 					message: res.data.msg,
				// 					type: 'success'
				// 				});
				// 				this.form.phone = ""
				// 				this.adminShow = true
				// 				this.adminData = res.data.data
				// 			} else {
				// 				this.$message({
				// 					message: res.data.msg,
				// 					type: 'error'
				// 				});
				// 			}
				// 		}).catch(err => {
				// 			console.log(err)
				// 		})
				// 	} else {
				// 		return false;
				// 	}
				// });
			}
		},
	}
</script>
<style lang="scss" scoped>
	@keyframes dong {
		0% {
			transform: translate(0px, 0px);
		}

		50% {
			transform: translate(-10px, 0px);
		}

		100% {
			transform: translate(0px, 0px);
		}
	}

	.boxFixed {
		position: fixed;
		bottom: 0;
	}

	.gov-tel {
		margin: 0;
		position: relative;
		padding: 0;
		animation: dong 1s infinite;
	}

	.gov-tel .gov-tel-animation {
		width: 125px;
		height: 40px;
		background: url(../../../assets/circle/biankuang.png) no-repeat 50%;
		display: inline-block;
		position: absolute;
		left: -132px;
		top: -79px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		-webkit-animation: gov-tel-animation-data-v-fe7916a0 1s ease-in-out infinite;
		animation: gov-tel-animation-data-v-fe7916a0 1s ease-in-out infinite;
		font-weight: 600;
		color: #FABE00;
	}

	.gov-tel .gov-tel-animation>span {
		margin-right: 5px;
	}

	/deep/.el-input__inner {
		padding-left: 14px;
		margin-left: 46px;
		width: 228px;
		height: 50px;
		background: #f5f6f6;
		border-radius: 8px;
		border: none;
	}

	.bottom-phone-big-box {
		position: relative;
		margin-left: 40px;
		line-height: 62.8px;
	}

	/deep/ .el-form-item {
		margin-bottom: 0;
	}

	/deep/ .el-form-item__error {
		left: 13px;
	}

	.get-btn {
		margin: -2px 0 0 18px;
		width: 168px;
		height: 45px;
		background: #FABE00;
		border: none;
		border-radius: 8px;
		font-size: 17px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #fff;
		text-align: center;
		cursor: pointer;
		margin-left: 70px;
		position: relative;
		z-index: 999;
	}
</style>
<style scoped>
	/deep/ .admin-dialog {
		background: url('../../../assets/index_popur.png') no-repeat;
		background-size: 100%;
		box-shadow: none;
		height: 560px;
		width: 850px;
	}

	/deep/ .admin-dialog .el-dialog__headerbtn .el-dialog__close {
		color: white;
		font-size: 20px;
	}

	.qrcode img {
		width: 158px;
		right: -95px;
		top: 214px;
		position: relative;
	}

	.footer {
		width: 100%;
		box-shadow: 0 2px 9px 0 rgb(0 0 0 / 8%);
		margin-top: 40px;
	}

	.footer-width {
		/* width: 1200px; */
		margin: 0 auto;
	}

	.footer-nav-beian {
		width: 100%;
		background: #fcfcfc;
		padding: 20px 0;
	}

	.footer-nav-beian a {
		color: #a3a8ab;
	}

	.footer-nav-beian div {
		width: 1200px;
		margin: 0 auto;
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #a3a8ab;
		text-align: center;
		line-height: 22px;
	}

	.decorate-line {
		margin: 0 10px;
	}

	.footer-nav-link-wrap {
		width: 1000px;
		margin: 0 auto 10px;
		height: 136px;
		display: flex;
		justify-content: space-between;
		position: sticky;
		top: 0;
		z-index: 100;
		padding: 10px 0 20px 0;
	}

	.footer-nav_div {
		width: 333px;
	}

	.footer-nav_div img {
		display: block;
		width: 190px;
		margin: 30px 0 0 0;
	}

	.footer-nav-link-wrap .footer-nav_divs {
		margin-left: 0;
		margin-top: 25px;
		width: 225px;
		text-align: left;
	}

	.footer-nav-link-wrap .footer-nav_divs div {
		box-sizing: border-box;
	}

	.footer-nav-link-wrap .footer-nav_dive {
		margin-top: 20px;
	}

	.app-wx {
		font-size: 12px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #a3a8ab;
		text-align: center;
	}

	.app-wx_img {
		width: 89px;
		height: 89px;
		border: 1px solid #e7e9e9;
		margin-bottom: 10px;
	}

	.app-wx .app-wx-icon {
		vertical-align: middle;
	}

	.footer-nav-link-wrap .footer-nav_divs h2 {
		text-align: left;
		font-size: 20px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #36404a;
	}

	.footer-nav-link-wrap .footer-nav_divs p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #747c80;
	}

	.footer-phone {
		margin: 30px 0 6px;
		line-height: 25px;
		height: 25px;
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #fabe00;
	}

	.footer-phone img {
		vertical-align: middle;
		margin-right: 8px;
	}

	.footer-link {
		display: flex;
		justify-content: space-between;
		margin-top: 40px;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #18252c;
		cursor: pointer;
	}

	.footer-link a {
		color: #18252c;
		text-decoration: none;
	}

	/* bottom 悬浮框 */
	#bottom-box {
		left: 0;
	}

	.bottom-phone-box {
		width: 100%;
		height: 100px;
		z-index: 1000;
		background: url('../../../assets/footer/foot-main.png') repeat;
		background-size: 100% 100%;
	}

	.college-big-box {
		display: flex;
		width: 1200px;
		margin: 0 auto;
		align-items: center;
		position: relative;
	}

	.teacher {
		position: relative;
		width: 120px;
		height: 100px;
		margin-left: 102px;
	}

	.teacher img {
		position: absolute;
		width: 113px;
		top: -57px;
		left: -40px;
	}

	.bottom-phone-box .right {
		position: absolute;
		top: -95px;
		right: 20px;
		z-index: 8
	}

	.bottom-phone-box .right img {
		width: 285px;
	}

	.text {
		font-size: 18px;
		font-weight: 600;
		color: #fff;
		line-height: 100px;
	}

	.text span {
		color: #FABE00;
		font-size: 32px;
	}

	/* left 悬浮框 */
	.big-box {
		position: fixed;
		bottom: 17%;
		right: 0;
		z-index: 99;
		width: 70px;
		background: #fff;
		box-shadow: 0 2px 9px 0 rgb(0 0 0 / 13%);
		border-radius: 6px 0 0 6px;
	}

	.big-box .service-wrapper {
		width: 100%;
		text-align: center;
		background: #fff;
		box-shadow: 0 2px 9px 0 rgb(0 0 0 / 13%);
		border-radius: 6px 0 0 6px;
	}

	.margin-wrapper-servicer {
		margin: 0 4px;
		margin: 5px auto 10px;
		border-bottom: 1px solid #ebebeb;
		min-height: 55px;
	}

	.margin-wrapper-servicer .router-link-active {
		padding: 0;
	}

	.margin-wrapper-servicer img {
		margin-bottom: 4px;
	}

	.margin-wrapper-servicer a {
		text-align: center;
		display: block;
		text-decoration: none;
	}

	.margin-wrapper-servicer a>div {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 400;
		color: #18252c;
	}

	/* 悬浮 */
	.router-link-active {
		margin: 10px auto 12px;
		padding: 0 0 10px 0;

	}

	.router-link-active img {
		margin-bottom: 5px;
	}

	.service-wrapper {
		padding: 10px 0;
		font-size: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/components/view/Footer/index.vue